var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWave = function SvgWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1280 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m0 71.635 107-20c106-19 320-57 533-51 213 7 427 58 533 83l107 26v192H0v-230Z",
    fill: "#09F"
  })));
};

export { SvgWave as ReactComponent };
export default __webpack_public_path__ + "1face46458943902208d9269f261f2e3.svg";